import React from 'react';
import { flash } from 'react-animations';
import styled, {keyframes} from 'styled-components';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { obtenirCoproActive, obtenirNumeroServeur } from '../../App_Code/Utils';
import { RoutesCopRattachee } from '../../App_Data/Routes';
import ConseilSyndical from '../../App_Data/ConseilSyndical';
import logo from '../../Img/Gmc_Blanc_Petit.svg';

const GMC_URL = process.env.NODE_ENV === 'production' ? window.env.GMC_URL : process.env.REACT_APP_GMC_URL;

const BoutonGMC = ({ Id, className }) => (
    <a
        href={`${GMC_URL}/Choix_copro.aspx?KELId=GMC|${Id}`}
        role="button"
        className={`btn btn-success ml-3 ${className}`}
    >
        <i>Retourner sur l&apos;ancienne interface</i>
    </a>
);

/* Barre de navigation, à gauche */
const SideNav = () => (
    <div>
        <div className="navbar-nav navbar-sidenav">
            {RoutesCopRattachee.map(route =>
                (!route.sidenav ? null : (
                    <NavLink
                        key={route.path}
                        to={route.path}
                        activeClassName="active"
                        className="nav-item nav-link"
                        data-placement="right"
                        title={route.titre}
                        onClick={() => {
                            document.getElementById('navbarResponsive').classList.remove('show');
                        }}
                    >
                        <i className={`fa fa-fw ${route.picto}`} />
                        <span className="ml-3 nav-link-text">{route.titre}</span>
                    </NavLink>
                )))}
        </div>
        <ul className="navbar-nav sidenav-toggler">
            <li className="nav-item">
                <a
                    href=" "
                    className="nav-link text-center"
                    id="sidenavToggler"
                    onClick={(event) => {
                        event.preventDefault();
                        if (document.body.classList.contains('sidenav-toggled')) {
                            document.body.classList.remove('sidenav-toggled');
                        } else document.body.classList.add('sidenav-toggled');
                    }}
                >
                    <i className="fa fa-fw fa-angle-left" />
                </a>
            </li>
        </ul>
    </div>
);

/* Sélection de la copropriété, en haut au milieu */
const LigneCopro = ({
    NumAuto, NomCopro, EstActif, NomAgence, Ind,
}) => {
    const composant = (
        <React.Fragment>
            <strong>
                {NomAgence} - {NomCopro}
            </strong>
            <div className="dropdown-message small">
                {Ind.Civilite} {Ind.Nom}
            </div>
        </React.Fragment>
    );

    return (
        <React.Fragment>
            <div className="dropdown-divider" />
            {EstActif ? (
                <div className="dropdown-item active">{composant}</div>
            ) : (
                <Link to={{ pathname: '/Chargement', state: { changementCopSel: NumAuto } }} className="dropdown-item">
                    {composant}
                </Link>
            )}
        </React.Fragment>
    );
};

const DropDownCopro = ({ ListeCopExts, NumAutoCopSel }) => {
    const coproActive = obtenirCoproActive(ListeCopExts, NumAutoCopSel);
    const lots = ListeCopExts.map((item, i) => <LigneCopro key={i} {...item} EstActif={item === coproActive} />);
    const oCS = ConseilSyndical(coproActive && coproActive.Ind ? coproActive.Ind.CS : '');

    return (
        <ul className="navbar-nav ml-auto">
            <li className="nav-item dropdown">
                <a
                    className="nav-link dropdown-toggle"
                    id="coproDropdown"
                    href=" "
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    {coproActive ? (
                        <span>
                            <strong>{coproActive.NomAgence}</strong> - {coproActive.NomCopro} -{' '}
                            <i className={oCS.Icone} title={oCS.TitreLong} /> {coproActive.Ind.Civilite}{' '}
                            {coproActive.Ind.Nom}
                        </span>
                    ) : (
                        <span>
                            <strong>{ListeCopExts.length > 0 ? 'Mes copropriétés' : 'Aucune copropriété'}</strong>
                        </span>
                    )}
                </a>
                <div className="dropdown-menu dropdown-menu-right scrollable-menu" aria-labelledby="coproDropdown">
                    {ListeCopExts.length > 0 && (
                        <React.Fragment>
                            <h6 className="dropdown-header">Mes copropriétés</h6>
                            {lots}
                            <div className="dropdown-divider" />
                        </React.Fragment>
                    )}
                    <Link
                        to="/AjoutCopro"
                        className="dropdown-item small"
                        onClick={() => document.getElementById('navbarResponsive').classList.remove('show')}
                    >
                        Rattacher une copropriété
                    </Link>
                </div>
            </li>
        </ul>
    );
};

const Flash = styled.div`animation: 3s ${keyframes`${flash}`} infinite`;

/* Gestion du compte adhérent, en haut à droite */
const DropDownCompte = ({ Email, Nom, PremiereCnx }) => (
    <ul className="navbar-nav ml-auto">
        <li className="nav-item">
            <NavLink to="/Aide" className="nav-link" data-toggle="tooltip" data-placement="bottom" title="Aide">
                { PremiereCnx ? 
                    <Flash>
                        <i className="fa fa-lg fa-question-circle text-info" />
                        <span className="d-lg-none"> Aide</span>
                    </Flash>
                :
                    <React.Fragment>
                        <i className="fa fa-lg fa-question-circle" />
                        <span className="d-lg-none"> Aide</span>
                    </React.Fragment>
                }
            </NavLink>
        </li>
        <li className="nav-item dropdown">
            <a
                className="nav-link dropdown-toggle"
                id="AdhDropdown"
                href=" "
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                <span>{Email} </span>
            </a>
            <div className="dropdown-menu dropdown-menu-right">
                <h6 className="dropdown-header">
                    <i className="fas fa-user mr-2" /> {Nom}
                </h6>
                <Link to="/ChangerMotdepasse" className="dropdown-item" data-placement="bottom">
                    <i className="fas fa-key mr-2" /> Changer de mot de passe
                </Link>
                <Link to="/Deconnexion" className="dropdown-item" data-placement="bottom">
                    <i className="fas fa-sign-out-alt mr-2" /> Déconnexion
                </Link>
            </div>
        </li>
    </ul>
);

/* Composant principal */
const Header = ({ Adh, NumAutoCopSel, CompteNonVide }) => (
    <div className="Menu">
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top" id="mainNav">
            <button
                className="navbar-toggler navbar-toggler-right collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#navbarResponsive"
                aria-controls="navbarResponsive"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span className="navbar-toggler-icon" />
            </button>
            <Link to="/">
                <img
                    src={logo}
                    className="app-logo mx-auto"
                    alt="Gérer ma copro"
                    title="Gérer ma Copro"
                    aria-label={obtenirNumeroServeur()}
                    aria-hidden="true"
                />
            </Link>
            {/* <BoutonGMC className="d-none d-xl-block" {...Adh} /> */}
            <div className="collapse navbar-collapse" id="navbarResponsive">
                {CompteNonVide && <SideNav />}
                <DropDownCopro ListeCopExts={Adh.LsCopExts} NumAutoCopSel={NumAutoCopSel} />
                <DropDownCompte Email={Adh.Email} Nom={Adh.Nom} PremiereCnx={Adh.PremiereCnx} />
            </div>
        </nav>
    </div>
);

function mapStateToProps({ AdhStore: { Adh, NumAutoCopSel } }) {
    return { Adh, NumAutoCopSel };
}

export default withRouter(connect(mapStateToProps)(Header));



// WEBPACK FOOTER //
// ./src/components/App/Header.js